<template>
  <div class="container">
    <div class="columns">
      <div class="column is-6">
        <div class="box">
          <admin-box-item title="상세 내용">
            <div class="content">
              <div class="label">해당 위치</div>
              <div>{{ locationText(qa) }}</div>
            </div>
            <div class="content">
              <div class="label">기대 결과</div>
              <div>{{ qa.location.result }}</div>
            </div>

            <div class="content flex">
              <div class="label">요청자</div>
              <div>{{ qa.req_user_name }}</div>
            </div>

            <div class="content flex">
              <div class="label">담당자</div>
              <div>{{ qa.task_user_name }}</div>
            </div>

            <div class="content">
              <div class="label">요청 내용</div>
              <div>{{ qa.req_content }}</div>
            </div>
          </admin-box-item>
        </div>
      </div>
      <div class="column is-6">
        <div class="box">
          <admin-box-item title="댓글">
            <div class="flex-column">
              <div class="list-comment">
                <div v-if="commentList.length === 0" style="padding:8px;text-align: center;color:#777">등록된 댓글이 없습니다</div>
                <div v-for="(item,idx) in commentList" :key="'comment-'+idx" class="box-comment">
                  <div>{{ item.author_name }}<span style="margin-left:8px;font-size:11px">{{ item.created_time }}</span>
                    <span class="btn-delete unselect" @click="delComment(item, idx)">삭제</span></div>
                  <div>{{ item.content }}</div>

                </div>
              </div>
              <div class="flex" style="margin-top:8px">
                <textarea v-model="comment" placeholder="댓글을 입력해주세요"
                          @keyup="e=> comment = e.target.value" rows="2"></textarea>
                <button class="button is-primary" style="width:60px" @click="regComment">등록</button>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>
    <div class="flex-end">
      <button class="button is-primary" @click="$emit('close')">닫기</button>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    name: "QaSheetDetailModal",
    props: {
      qa: {
        type: Object
      }
    },
    created() {
      this.getComments();
    },
    data() {
      return {
        commentList: [],
        comment: ''
      }
    },
    methods: {
      getComments() {
        this.$axios.get(`admin/launchpack/qa_sheet/${this.qa.id}/comment?page_length=100`).then(res=>{
          this.commentList = res.data.data;
        });
      },
      regComment() {
        if(this.comment.trim()==='') {
          return;
        }
        this.$axios.post(`admin/launchpack/qa_sheet/${this.qa.id}/comment`, {
          author_id: this.$store.getters.admin.id,
          sheet_id: this.qa.id,
          content: this.comment
        }).then(res=>{
          this.commentList.splice(0,0, {
            content: this.comment,
            created_time: moment().format('YYYY-MM-DD HH:mm'),
            id: res.data.id,
            author_name: this.$store.getters.admin.name,
            author: this.$store.getters.admin.id
          });
          this.comment = '';
        });
      },
      delComment(item, idx) {
        if(confirm('댓글을 삭제하시겠습니까?')) {
          this.$axios.delete(`admin/launchpack/qa_sheet/${this.qa.id}/comment/${item.id}`).then(()=>{
            removeIndex(this.commentList, idx);
          });
        }
      },
      locationText() {
        let result = '';
        if (this.qa.location.type === 'front_action') {
          result = `[프론트] ${this.qa.location.location_name} > ${this.qa.location.feature_name} > ${this.qa.location.name}`;
        } else {
          result = `[${this.qa.location.type === 'admin_feature' ? '백오피스' : '빌더'}] ${this.qa.location.location_name} > ${this.qa.location.content}`;
        }

        return result;
      },
    }
  }
</script>

<style lang="stylus" scoped>
  .container
    padding 20px
    background #dddddd
  .content
    margin-top 20px
    white-space pre-line
  .content:first-child
    margin-top 0
  .content:last-child
    margin-bottom 40px
  .label
    margin-bottom 4px !important
    margin-right 8px

  textarea
    flex 1
    border 1px solid #dddddd
    padding 4px 8px
    border-radius 4px
    margin-right 4px

  .box-comment
    border-bottom 1px solid #eee
    padding 8px 0
    white-space pre-line

  .list-comment
    max-height 400px
    overflow-y auto
    border 1px solid #dddddd
    padding 8px 12px

  .btn-delete
    font-size 12px
    color #777
    margin-left 8px
  .btn-delete:hover
    color #ff5722
</style>
